import { useMutation } from "@apollo/client";
import { GAME_ORDER_UPDATE } from "graphql/mutation/game-gql";
import { Localize } from "components/service";

const useMutationGameOrder = () => {
  const [updateOrder, { loading }] = useMutation(GAME_ORDER_UPDATE);
  const invalidResponseMessage = Localize({ children: "APP_SETTINGS.Error_InvalidResponse" }).props.children;

  const setOrder = async ({ id, row_order }) => {
    const result = await updateOrder({ variables: { input: { id, row_order } } });
    const savedGame = result.data?.gameUpdate?.game;
    if (String(savedGame?.id ?? "") !== String(id) || savedGame?.row_order !== row_order) throw new Error(invalidResponseMessage);
    return result;
  };

  return { setOrder, loadingMutationGameOrder: loading };
};

export default useMutationGameOrder;
